import { render } from "./DirectoryListReport.vue?vue&type=template&id=321ce98e&scoped=true"
import script from "./DirectoryListReport.vue?vue&type=script&lang=js"
export * from "./DirectoryListReport.vue?vue&type=script&lang=js"

import "./DirectoryListReport.vue?vue&type=style&index=0&id=321ce98e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321ce98e"]])

export default __exports__